export const PdfConstants = {
  MAX_ZOOM: 2,
  MIN_ZOOM: 0.5,
  SCALE_STEP: 0.25,
  PAGE_STEP: 1,
  MIN_PAGE: 1
}
